<script>
    import Header from "../Headers/Header.svelte";
    import Button from "../Buttons/Button.svelte";
</script>

<style type="text/scss">
    @import "../../styles/_mixins.scss";

    .zig-zag {
        background-color: #f7f7f7;
        width: 100vw;
        position: relative;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        padding-top: var(--spacer-medium);
        padding-bottom: var(--spacer-medium);
        margin-bottom: var(--spacer-large);
        @include sm {
            padding-top: var(--spacer-large);
            padding-bottom: var(--spacer-large);
            margin-bottom: var(--spacer-large);
        }
    }

    .step {
        display: flex;
        align-items: center;
        margin: 0 auto;
        max-width: 850px;
        margin-bottom: var(--spacer-large);
        padding: var(--spacer-medium);

        @include sm {
            padding: var(--spacer-small);
        }

        h2 {
            font-size: var(--font-large);
            margin-bottom: var(--spacer-tiny);

            @include sm {
                font-size: var(--font-massive);
            }
        }

        p {
            font-size: var(--font-regular);
            color: rgba(22, 12, 40, 0.3);
            margin-bottom: var(--spacer-medium);

            @include sm {
                font-size: var(--font-large);
            }
        }

        img {
            width: 50%;
            @include sm {
                width: 500px;
            }
        }
    }
</style>

<div class="zig-zag">
    <Header title="How it works" />

    <div class="step">
        <div>
            <h2>Create your profile</h2>
            <p>
                Tell us about yourself so people know who you are and what
                you're looking for.
            </p>
        </div>
        <img
            alt="two people sitting on a couch talking"
            src="https://assets.umso.co/7/15_education_general.svg" />
    </div>

    <div class="step">
        <img
            alt="two people sitting on a couch talking"
            src="https://assets.umso.co/7/16_message_sent_general.svg" />
        <div style="margin-left: var(--spacer-large)">
            <h2>Discover new people</h2>
            <p>
                We'll show you relevant people we think you might be interested
                in.
            </p>
        </div>
    </div>

    <div class="step">
        <div>
            <h2>Schedule a 1:1 call</h2>
            <p>Jump straight into a call with them and start talking!</p>
            <Button
                text="Start Now"
                primary
                onClick={() => window.location.replace('/account')} />
        </div>
        <img
            alt="two people sitting on a couch talking"
            src="https://assets.umso.co/7/5_student_general.svg" />
    </div>
</div>
